/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_File_Statistics_PendingInputs */



/**
* | output |
* | --- |
* | "Embedding" |
*
* @param {Spaces_File_Statistics_PendingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_file_statistics_pending = /** @type {((inputs?: Spaces_File_Statistics_PendingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_File_Statistics_PendingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Einbettung")
	return /** @type {LocalizedString} */ ("Embedding")
});